var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{class:{ isPortal: _vm.isFullscreen, isDiv: !_vm.isFullscreen }},[_c('div',{staticClass:"spinner",attrs:{"to":"Loading"}},[_c('b-spinner',{staticClass:"m-2",attrs:{"variant":"primary","role":"status"}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }